import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { requests } from '../../../core/ajax'
import { feedback } from '../../../core/feedback'

export const useCampaignsCalls = () => {
  const { get, getById, putById, post, deleteById } = requests
  const { formatMessage } = useIntl()

  const noResponseError = () =>
    feedback('error', formatMessage({ id: 'calls.responseless.error.description' }))
  const defaultError = () =>
    feedback('error', formatMessage({ id: 'calls.default.error.description' }))

  const displayError = (message) => {
    feedback('error', message)
  }

  const getCampaignsCall = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        get('/campana/tabla_campanas', config)
          .then((response) => resolve(response))
          .catch((error) => {
            const { response } = error
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 403:
                return reject(response)
              default:
                console.error('Error fetching campaigns:', error)
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const getCampaignCall = useCallback(
    (id, config) =>
      new Promise((resolve, reject) => {
        getById('/campana', id, config)
          .then((response) => resolve(response))
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case '403': //Permisson denied by role
                return reject(response)
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const postCampaignCall = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        post('/campana', config)
          .then((response) => resolve(response))
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case '403': //Permisson denied by role
                return reject(response)
              case 400: //Permisson denied by role
                displayError(response.data.message)
                return reject(response.status)
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const putCampaignCall = useCallback(
    (id, config) =>
      new Promise((resolve, reject) => {
        putById('/campana', id, config)
          .then((response) => resolve(response))
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case '403': //Permisson denied by role
                return reject(response)
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const putCampaignStatusCall = useCallback(
    (id, config) =>
      new Promise((resolve, reject) => {
        putById('/campana/cambiar_estado', id, config)
          .then((response) => resolve(response))
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case '403': //Permisson denied by role
                return reject(response)
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const getZipMunicipalities = useCallback((type, code) => {
    return new Promise((resolve, reject) => {
      const config = { params: { [type]: code } }
      get('/campana/codigos_postales', config).then(({ data }) => resolve(data))
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const deleteCampaigns = useCallback(
    (id, config) =>
      new Promise((resolve, reject) => {
        deleteById('/campana', id, config)
          .then(({ data }) => resolve(data))
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case '403': //Permisson denied by role
                return reject(response)
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    []
  )

  const getCampaignCodesFilter = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        get('/campana/codigos', config)
          .then((response) => resolve(response))
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case '403': //Permisson denied by role
                return reject(response)
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return {
    getCampaignsCall,
    getCampaignCall,
    postCampaignCall,
    putCampaignCall,
    putCampaignStatusCall,
    getZipMunicipalities,
    deleteCampaigns,
    getCampaignCodesFilter,
  }
}
